import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton TanStack Query Client fuer die Scanner App.
 * Kurze stale time da Check-in Daten immer aktuell sein muessen.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      gcTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
